/* Adapt legacy fixed-color product HTML only where light-mode contrast fails.
   Image backgrounds are left to their original design; inline colors are restored on theme changes. */
(() => {
  const originals = new Map();
  const rgb = value => {
    const match = value.match(/^rgba?\(([^)]+)\)$/);
    return match ? match[1].split(/[,\s/]+/).filter(Boolean).map(Number) : null;
  };
  const luminance = c => c.slice(0,3).reduce((sum,n,i) => {
    n /= 255;
    return sum + (n <= .04045 ? n / 12.92 : ((n+.055)/1.055)**2.4) * [.2126,.7152,.0722][i];
  },0);
  const ratio = (a,b) => (Math.max(luminance(a),luminance(b))+.05)/(Math.min(luminance(a),luminance(b))+.05);
  function background(node) {
    const layers = [];
    for(let el=node;el;el=el.parentElement){
      const style=getComputedStyle(el);
      if(style.backgroundImage !== 'none') return null;
      const color=rgb(style.backgroundColor);
      if(color){layers.push(color);if((color[3] ?? 1)>=1)break;}
    }
    return layers.reverse().reduce((base,c)=>base.map((v,i)=>c[i]*(c[3]??1)+v*(1-(c[3]??1))),[255,255,255]);
  }
  function adapt() {
    originals.forEach((saved,el)=>saved.value ? el.style.setProperty('color',saved.value,saved.priority) : el.style.removeProperty('color'));
    originals.clear();
    if(document.documentElement.dataset.appTheme !== 'minimalLight')return;
    const updates=[];
    document.querySelectorAll('.begode-product-details__content *').forEach(el=>{
      if(el.closest('svg,style,script') || !Array.from(el.childNodes).some(n=>n.nodeType===3&&n.textContent.trim()))return;
      const bg=background(el), style=getComputedStyle(el), color=rgb(style.color);
      if(!bg || !color || style.display==='none')return;
      const fg=bg.map((v,i)=>color[i]*(color[3]??1)+v*(1-(color[3]??1)));
      if(ratio(fg,bg)>=4.5)return;
      const dark=[23,33,43], white=[255,255,255], gold=[117,77,0];
      const warm=color[0]>color[2]*1.2&&color[1]>color[2]*1.1;
      const next=warm&&ratio(gold,bg)>=4.5 ? gold : ratio(dark,bg)>ratio(white,bg)?dark:white;
      updates.push([el,next]);
    });
    updates.forEach(([el,color])=>{
      originals.set(el,{value:el.style.getPropertyValue('color'),priority:el.style.getPropertyPriority('color')});
      el.style.setProperty('color',`rgb(${color.join(',')})`,'important');
    });
  }
  let frame;
  const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(adapt);};
  new MutationObserver(schedule).observe(document.documentElement,{attributes:true,attributeFilter:['data-app-theme']});
  document.addEventListener('shopify:section:load',schedule);
  window.addEventListener('load',schedule);
  schedule();
})();
